import ApiClient from "./apiClient";
import { getListParams, QueriesApi } from "./apiTypes";


const sshService = {
  getSshKeys:(queries:QueriesApi={page:1, page_size:100, ordering:'-created_at'}) => ApiClient.get('pkm', {params:getListParams(queries)}),
  generateKeyPair: () => ApiClient.get('pkm/get_generated_key_pair'),
  createSsh:(data:any) => ApiClient.post('pkm', data),
  editSsh:(data:any) => ApiClient.put(`pkm/${data.id}`, data),
  deleteSsh:(id:string) => ApiClient.delete(`pkm/${id}`),
  getSshById:(id:string) => ApiClient.get(`pkm/${id}`)
}

export default sshService
